/* eslint-disable no-magic-numbers */
import React, { DragEvent } from 'react';
import clsx from 'clsx';

import { FormattedMessage } from '@futrli/localisation';

import Icon from 'carbon-react/lib/components/icon';
import RadioButton, { RadioButtonGroup } from 'carbon-react/lib/components/radio-button';

import { TextPanel } from '../text-panel/text-panel';
import { CARD_TYPES, PAGE_NUMBERS_DISPLAY } from '../../types';
import { useReportBuilderContext } from '../../report-builder.context';

import styles from './sidebar.scss';

export const SidebarTextPanel = ({
  onItemDragStart
}: {
  onItemDragStart: (
    e: DragEvent<HTMLDivElement | HTMLSpanElement>,
    type: CARD_TYPES,
    data?: Record<string, unknown>
  ) => void;
}) => {
  const {
    pageSetup: { pageNumbersDisplay },
    setReportPageNumbersDisplay
  } = useReportBuilderContext();

  const handlePageNumbersChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setReportPageNumbersDisplay(event.target.value as PAGE_NUMBERS_DISPLAY);

  return (
    <div className={clsx(styles.sidebarTextPanel)}>
      <div className={styles.subtitle} style={{ marginBottom: 10 }}>
        <FormattedMessage id="reporting.text_blocks" defaultMessage="Text blocks" />
      </div>
      <button
        className={clsx(styles.addTextBtn)}
        onClick={() => null}
        onDragStart={e => onItemDragStart(e, CARD_TYPES.TEXT, {})}
        draggable
      >
        <Icon type="file_word" color="#fff" />
        <FormattedMessage id="reporting.add_text_block" defaultMessage="Add text block" />
      </button>
      <TextPanel />
      <div style={{ marginTop: 20 }}>
        <div className={styles.subtitle}>
          <FormattedMessage id="reporting.available_placeholders" defaultMessage="Available dynamic placeholders" />
        </div>
        <small>
          <code>{'@REPORT_DATE'}</code>{' '}
          <FormattedMessage
            id="reporting.dynamic_placeholder_current_date"
            defaultMessage="dynamic placeholder for current date."
          />
        </small>
      </div>
      <div style={{ marginTop: 20 }}>
        <div className={styles.subtitle}>
          <FormattedMessage id="reporting.page_numbers" defaultMessage="Page numbers" />
        </div>
        <RadioButtonGroup
          name="page-numbers-radio-group"
          onChange={handlePageNumbersChange}
          value={pageNumbersDisplay}
          mt={1}
        >
          <RadioButton
            value={PAGE_NUMBERS_DISPLAY.NONE}
            label={<FormattedMessage id="common.page_number_none" defaultMessage="None" />}
            checked={pageNumbersDisplay === PAGE_NUMBERS_DISPLAY.NONE}
          />
          <RadioButton
            value={PAGE_NUMBERS_DISPLAY.ONE}
            label="1"
            checked={pageNumbersDisplay === PAGE_NUMBERS_DISPLAY.ONE}
          />
          <RadioButton
            value={PAGE_NUMBERS_DISPLAY.ONE_OF_ONE}
            label={<FormattedMessage id="reporting.1_of_1" defaultMessage="1 of 1" />}
            checked={pageNumbersDisplay === PAGE_NUMBERS_DISPLAY.ONE_OF_ONE}
          />
          <RadioButton
            value={PAGE_NUMBERS_DISPLAY.PAGE_ONE}
            label={<FormattedMessage id="reporting.page_1" defaultMessage="Page 1" />}
            checked={pageNumbersDisplay === PAGE_NUMBERS_DISPLAY.PAGE_ONE}
          />
          <RadioButton
            value={PAGE_NUMBERS_DISPLAY.PAGE_ONE_OF_ONE}
            label={<FormattedMessage id="reporting.page_1_of_1" defaultMessage="Page 1 of 1" />}
            checked={pageNumbersDisplay === PAGE_NUMBERS_DISPLAY.PAGE_ONE_OF_ONE}
          />
        </RadioButtonGroup>
      </div>
    </div>
  );
};
